import React from 'react';
import PropTypes from 'prop-types';

import styles from './ErrorApiHandler.css';

const IPropTypes = {
  message: PropTypes.string,
  content: PropTypes.arrayOf(PropTypes.string),
};

const defaultProps = {
  message: '',
  content: () => [],
};

/*
  This component listens for any uncaught error on the whole tree.
  If any error reaches this component, a fallback UI is shown.
*/

// eslint-disable-next-line react/prefer-stateless-function
class ErrorApiHandler extends React.Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className={styles.container}>
        <div className={styles.message}>{this.props.message}</div>
        <div>
          {this.props.content &&
          Array.isArray(this.props.content) && this.props.content.map(x => <div>- {x}</div>)}
        </div>
      </div>
    );
  }
}

ErrorApiHandler.propTypes = IPropTypes;
ErrorApiHandler.defaultProps = defaultProps;

export { ErrorApiHandler };



// WEBPACK FOOTER //
// ./src/common/error-api-handler/ErrorApiHandler.jsx